import { Injectable } from '@angular/core';
import { HttpEvent } from '@angular/common/http';

import { Observable } from 'rxjs';

import { UploadIds } from 'src/app/models/upload';
import { Intervention } from 'src/app/models/intervention';
import { InterventionContentItem } from '../../../models/intervention-content-item';
import { ApiService } from 'src/app/core/services/api/api.service';

@Injectable({
  providedIn: 'root',
})
export class InterventionService {
  saveIntervention(intervention: Intervention & { study_id: number }): Observable<Intervention> {
    return this.apiService.post<Intervention>(`/dashboard/study/${intervention.study_id}/intervention`, intervention);
  }

  getIntervention(studyId: number, interventionId: number): Observable<Intervention> {
    return this.apiService.get<Intervention>(`/dashboard/study/${studyId}/intervention/${interventionId}`);
  }

  updateIntervention(intervention: Intervention & { study_id: number }): Observable<Intervention> {
    return this.apiService.put<Intervention>(
      `/dashboard/study/${intervention.study_id}/intervention/${intervention.id}`,
      intervention
    );
  }

  uploadInterventionImage(imageFile: File, idsForUpload: UploadIds): Observable<HttpEvent<string[]>> {
    const body: FormData = new FormData();
    body.append('uploads[]', imageFile, imageFile.name);

    return this.apiService.post<HttpEvent<string[]>>(
      `/dashboard/study/${idsForUpload?.studyId || 0}/intervention/${idsForUpload?.interventionId || 0}/upload`,
      body,
      {
        reportProgress: true,
        observe: 'events',
      }
    );
  }

  deleteIntervention(intervention: Intervention & { study_id: number }): Observable<Intervention> {
    return this.apiService.delete<Intervention>(
      `/dashboard/study/${intervention.study_id}/intervention/${intervention.id}`
    );
  }

  duplicateIntervention(intervention: Intervention & { study_id: number }): Observable<Intervention> {
    return this.apiService.post<Intervention>(
      `/dashboard/study/${intervention.study_id}/intervention/${intervention.id}`,
      []
    );
  }

  finishSession(intervention: Intervention & { study_id: number }): Observable<Intervention> {
    return this.apiService.put<Intervention>(
      `/dashboard/study/${intervention.study_id}/intervention/${intervention.id}`,
      intervention
    );
  }

  setStartModule(studyId: number, interventionId: number, moduleId: number): Observable<InterventionContentItem> {
    return this.apiService.put<{}>(
      `/dashboard/study/${studyId}/intervention/${interventionId}/compassstart/${moduleId}`,
      {}
    );
  }

  constructor(private apiService: ApiService) {}
}
